import WebsiteBrandConfig from './WebsiteBrandConfig';

const brand = process.env.NEXT_PUBLIC_BRAND;

// eslint-disable-next-line import/no-dynamic-require
const brandConfig: WebsiteBrandConfig = require(`./brandConfig.${brand}`).default;

export default brandConfig;
